import { type InfiniteData, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { type Board, type ListResponse } from '@air/types';

import { getPrivateBoardsListKey } from '~/components/v2/hooks/queries/usePrivateBoardsList';
import { useFavoriteBoardsParams } from '~/components/v2/hooks/useFavoriteBoardsParams';
import { getRearrangedBoards } from '~/utils/mutateUtils/mutators';

export const useFavoriteBoardsCacheUpdate = () => {
  const queryClient = useQueryClient();
  const { getFavoriteBoardsParams } = useFavoriteBoardsParams();

  const updateFavoriteBoardsCache = useCallback(
    ({ rearrangedBoards }: { rearrangedBoards: Board[] }) => {
      queryClient.setQueriesData<InfiniteData<ListResponse<Board>> | undefined>(
        {
          queryKey: getPrivateBoardsListKey(getFavoriteBoardsParams()),
        },
        getRearrangedBoards(rearrangedBoards),
      );
    },
    [getFavoriteBoardsParams, queryClient],
  );

  return {
    updateFavoriteBoardsCache,
  };
};
